/**
 * @generated SignedSource<<c51599bd6bd664c6e64863eabc027466>>
 * @relayHash 26966297cc4db38d5fe473e5edb4b804
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/417.0.0-2023-06-02T01:22:30.591Z/auctionWonRuleQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type AnchorSourceType = "ACTIVITY_FEED_ELEMENT" | "ACUITY_EVENT" | "ADDRESS" | "ADJUSTMENT" | "ADJUSTMENT_RATE" | "ARCARTA_VERIFICATION" | "ARTICLE" | "ATTRIBUTE" | "ATTRIBUTE_OPTION" | "AUCTION_LOT" | "AWARD" | "CARRIER" | "CATEGORY" | "CHARGE" | "CMS_PAGE" | "CMS_PAGE_TYPE" | "CONVERSATION" | "CREATOR" | "CURRENCY" | "DEPOSIT_INITIATION" | "DESIGNER" | "DESIGN_MANAGER" | "DM_PROJECT_ID" | "ECOM_EVENT" | "EMAIL" | "FAVORITE" | "FEE_STRUCTURE" | "FEE_STRUCTURE_CHARGE" | "FIRM" | "ICONIC_DESIGN" | "IDENTITY_VERIFICATION" | "INVOICE" | "ITEM" | "ITEM_HOLD" | "ITEM_IMAGE" | "ITEM_LISTING" | "ITEM_PRICE" | "ITEM_RECOMMENDATION" | "LEXIS_NEXIS_SEARCH" | "LOCATION" | "MAX_BID" | "MESSAGE" | "MESSAGE_ID" | "MONITOR" | "NFT_AUCTION" | "NFT_ITEM" | "NFT_LISTING" | "NOTE" | "OFFER" | "ORDER_FEEDBACK" | "ORDER_MODIFICATION" | "ORGANIZATION" | "PAGE" | "PAYMENT_AUTHORIZATION" | "PAYMENT_METHOD" | "PERMISSION" | "PHONE" | "PHOTO" | "PHOTO_TAG" | "PORTFOLIO" | "PORTFOLIO_ITEM" | "PROGRAM" | "PROGRAM_ENROLLMENT" | "PROMOTION" | "PROMOTION_RULE" | "PUBLICATION" | "PUBLICATION_TYPE" | "REFUND" | "RETURN" | "RETURN_POLICY" | "REVIEW" | "SALESFORCE" | "SALESFORCE_CASE" | "SELLER" | "SELLER_FEE_CHARGE" | "SHIPMENT" | "SHIPMENT_QUOTE" | "SHIPMENT_QUOTE_REQUEST" | "SHIPMENT_TRACKING" | "SKU" | "STOREFRONT_PROFILE" | "SUBSIDY_PROGRAM" | "TAXONOMY" | "TRADE_ASSOCIATION" | "TRADE_FIRM_PROJECT" | "TRADE_PROGRAM_CASH_REWARD" | "TRADE_REWARD" | "TRADE_STATE_DOCUMENT" | "TRANSACTION" | "TRANSFER" | "USER" | "USER_GROUP" | "VERTICAL" | "VIDEO" | "WALLET" | "WEBLINK" | "WEB_SOCKET" | "%future added value";
export type auctionWonRuleQuery$variables = {
  hasUserId: boolean;
  userId: string;
};
export type auctionWonRuleQuery$data = {
  readonly viewer: {
    readonly user?: {
      readonly activityFeed: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly anchors: ReadonlyArray<{
              readonly source: {
                readonly lastTransaction?: {
                  readonly isAuctionWonAndPending: boolean;
                } | null;
              } | null;
              readonly sourceType: AnchorSourceType | null;
            } | null> | null;
            readonly expirationDate: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly youWonAuctionNotification: boolean | null;
  };
};
export type auctionWonRuleQuery = {
  response: auctionWonRuleQuery$data;
  variables: auctionWonRuleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "alias": "youWonAuctionNotification",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "youWonAuctionNotification"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"youWonAuctionNotification\")"
},
v3 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "elementStatuses",
    "value": [
      "ACTIVE"
    ]
  },
  {
    "kind": "Literal",
    "name": "elementTypes",
    "value": [
      "BUYER_AUCTION_WON"
    ]
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expirationDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceType",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAuctionWonAndPending",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "auctionWonRuleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "ActivityFeedConnection",
                    "kind": "LinkedField",
                    "name": "activityFeed",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityFeedEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActivityFeedElement",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": (v7/*: any*/),
                                            "concreteType": "Transaction",
                                            "kind": "LinkedField",
                                            "name": "lastTransaction",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "Item",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "activityFeed(elementStatuses:[\"ACTIVE\"],elementTypes:[\"BUYER_AUCTION_WON\"])"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "auctionWonRuleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "ActivityFeedConnection",
                    "kind": "LinkedField",
                    "name": "activityFeed",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityFeedEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActivityFeedElement",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": (v7/*: any*/),
                                            "concreteType": "Transaction",
                                            "kind": "LinkedField",
                                            "name": "lastTransaction",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "Item",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "activityFeed(elementStatuses:[\"ACTIVE\"],elementTypes:[\"BUYER_AUCTION_WON\"])"
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/417.0.0-2023-06-02T01:22:30.591Z/auctionWonRuleQuery",
    "metadata": {},
    "name": "auctionWonRuleQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8db760a3d1ab0333a14f7ce7cbc3b38";

export default node;
